// extracted by mini-css-extract-plugin
export default {"root":"Viewer_root__qzDva","center":"Viewer_center__HbeoF"};